













































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import LocationTypeDto from '@/models/LocationTypes/LocationTypeDto';
import UpdateLocationTypeRequest from '@/models/LocationTypes/UpdateLocationTypeRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'LocationTypeEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new LocationTypeDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentLocationType));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
        if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateLocationTypeRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    await AgencySettingsModule.editLocationType(request)
    this.dialog = false;
  }
}
